import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'project-directory-redirect',
	path: '/secure/RapidBoard.jspa',
};
